import { FC, memo } from 'react'
import { Box, useToken, useColorModeValue } from '@chakra-ui/react'

type Props = {
  size?: number
}

const InvetoryModuleBrand: FC<Props> = ({ size = 12 }) => {
  const [primary200, primary300, primary400, primary500, primary600, primary700, primary900, white] = useToken('colors', [
    'primary.200',
    'primary.300',
    'primary.400',
    'primary.500',
    'primary.600',
    'primary.700',
    'primary.900',
    'white',
  ])

  const strokeColor900 = useColorModeValue(primary900, primary900)
  const strokenWidth = '40px'
  const fillColor200 = useColorModeValue(primary200, primary300)
  const fillColor400 = useColorModeValue(primary400, primary500)
  const fillColor600 = useColorModeValue(primary600, primary700)
  const fillBG = useColorModeValue(white, white)

  return (
    <Box w={size} h={size} pos="relative">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
        <g id="Estoque">
          <g id="background">
            <g id="group200">
              <path
                fill={fillColor200}
                opacity="0.25"
                d="M342.68,666.94c73,46.49,168.28,52.51,248.69,6.27,107.42-61.78,149.77-198.07,96.78-311.64l-1.08-2.27c-15.07-31.48-22.26-65.92-22.39-100.74A146.28,146.28,0,0,0,645,186C606,118.1,519.41,82.21,451.28,119c-26.39,14.24-33.89,72.27-67.66,112.62C360.83,258.8,288.49,277,253.13,273.26a189.15,189.15,0,0,0-119.6,27.11c-83.2,51.05-114.18,159.12-71.28,248,40,82.91,129.75,124.07,213.93,106.17A89.33,89.33,0,0,1,342.68,666.94Z"
              />
            </g>
            <g id="group400">
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M620.93,268.05c5.67-39.63-10-81-44.82-106-46.53-33.49-112-25.32-149.8,18.68l-.75.88a108.6,108.6,0,0,1-38.19,28.67,67.65,67.65,0,0,0-26.84,22.13c-21.16,29.4-15.18,70.67,13.31,92.37,11,8.4,41.47,17.5,64.92,24,15.82,4.4,26.77,11.66,31.93,27.28,5.86,17.76,32.17,38.83,56.22,37.7,45.11-2.13,53.07-12.22,83.31-46.44,13.56-15.35,36.3-28.81,12.69-60.87C616.51,297.79,619.39,278.82,620.93,268.05Z"
              />
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M456.61,509c-12.85,37.92-5,81.4,24.6,112.44,39.59,41.45,105.5,45.45,150.69,9.12l.9-.73a108.62,108.62,0,0,1,42.8-21.17A67.72,67.72,0,0,0,706,591.8c26.2-25,27.89-66.68,3.87-93.24-9.31-10.29-37.55-24.81-59.41-35.54-14.74-7.24-24.17-16.38-26.38-32.68-2.5-18.54-24.5-44.08-48.35-47.38-44.73-6.18-54.4,2.27-90.41,30.36-16.15,12.61-41,21.66-23.65,57.51C466.41,480.55,460.1,498.67,456.61,509Z"
              />
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M216.74,429.65c-34.94,19.52-58.31,57-57.12,99.92,1.59,57.3,47.82,104.46,105.7,107.79l1.16.06a108.78,108.78,0,0,1,45.95,13,67.59,67.59,0,0,0,33.87,7.93c36.21-1,65.4-30.78,65.37-66.6,0-13.87-11.22-43.58-20.25-66.2-6.08-15.25-6.95-28.36,2.34-41.93,10.57-15.43,11.37-49.13-4.12-67.56-29-34.58-41.89-34.8-87.44-38.09-20.43-1.48-44.92-11.39-56.09,26.82C243.08,415.13,226.24,424.34,216.74,429.65Z"
              />
            </g>
            <g id="group600">
              <path
                fill={fillColor600}
                d="M256.68,567.2C269,654.91,401.07,704.85,495.36,693.68,621.31,678.75,701.65,471.21,702,470.43c22.7-47.91,58.61-66.21,56.73-131.36-.73-25.14-8.09-64.06-50.63-92.51-66.62-44.55-77.54-12.1-156.26-21.2-106.78-12.35-125.17-57.82-230.58-76-53.45-9.22-109.37,3.24-146.9,41C104,261.29,93.8,335.75,136.84,412.61,170.62,473,244.24,478.35,256.68,567.2Z"
              />
              <path
                fill={fillColor600}
                d="M131.19,512.51c.46,10.73-4.41,21.18,4.7,25,4,1.67,18,4,18,8.27,0,.21,0,.42,0,.64a12.61,12.61,0,0,0,6.81,10.91,13.11,13.11,0,0,0,19.18-10,12.94,12.94,0,0,0-.81-6.36,17.86,17.86,0,0,1,1.16-15.84,26.46,26.46,0,1,0-49-12.66Z"
              />
              <path
                fill={fillColor600}
                d="M706.6,501.34c6.36-26.49,30.81-20.41,35-9.27,3.26,8.69,1.54,18.55-2.84,29.61s-22.47,16.68-24,17.74C700.44,549,697,541.1,706.6,501.34Z"
              />
              <path
                fill={fillColor600}
                d="M474.7,183a23.11,23.11,0,0,1,31.37-33.94c9.37,8.67,27.91,22.58,19.24,31.95S484.07,191.65,474.7,183Z"
              />
            </g>
          </g>
          <g>
            <path
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill={fillBG}
              d="M580.94,625.07H271.14a50.7,50.7,0,0,1-50.7-50.69h0V343.43h0A89.91,89.91,0,0,1,227.7,308l24.65-57.75h0A50.68,50.68,0,0,1,299,219.51h248.5a50.68,50.68,0,0,1,46.61,30.78L618.86,308h0A89.82,89.82,0,0,1,626,343.43V580h0a45.07,45.07,0,0,1-45.06,45.06Z"
            />
            <path
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
              d="M626,377.23h0a45.06,45.06,0,0,0-45.06-45.06H265.51a45.06,45.06,0,0,0-45.07,45.06h0"
            />
            <path
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
              d="M423.22,219.51V332.17"
            />
            <path
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
              d="M310.57,535h45.06"
            />
          </g>
        </g>
      </svg>
    </Box>
  )
}

export default memo(InvetoryModuleBrand)
